<template>
  <div
    :data-qa="itemDataQa"
    class="lpu-cards-filters-toggle-item d-flex align-center justify-space-between ga-4 px-4 py-2"
    :class="{ 'lpu-cards-filters-toggle-item--readonly': readonly }"
    @click="handleRowClick"
  >
    <div class="d-flex align-center ga-4 min-w-0">
      <v-icon
        size="24"
        color="icon-secondary"
      >
        {{ icon }}
      </v-icon>
      <div class="text-body-1 text--text">
        {{ title }}
      </div>
    </div>
    <v-switch
      :input-value="value"
      color="primary"
      class="lpu-cards-filters-toggle-item__switch pt-0 mt-0 flex-shrink-0"
      hide-details
      dense
      inset
      :readonly="readonly"
      @click.stop
      @change="handleSwitchChange"
    />
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  itemDataQa: string
  icon: string
  title: string
  value?: boolean
  readonly?: boolean
}>(), {
  value: false,
  readonly: false,
})

type Emits = {
  (_event: 'input', _value: boolean): void
}

const emit = defineEmits<Emits>()

function handleRowClick() {
  if (props.readonly) {
    return
  }

  emit('input', !props.value)
}

function handleSwitchChange(isEnabled: boolean) {
  if (props.readonly) {
    return
  }

  emit('input', isEnabled)
}
</script>

<style lang="scss" scoped>
.lpu-cards-filters-toggle-item {
  min-height: 56px;
  cursor: pointer;

  &--readonly {
    cursor: default;
  }

  &__switch {
    :deep(.v-input--selection-controls__input) {
      margin-right: 0;
    }
  }
}
</style>
